import { createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'

export const store = createStore(
    reducer,
    {
        view: 0,
        answer: {
            emprunteurs_hab_pays: { label: 'France', value: 'FRA' }, // must be 3 char max
        },
    },
    // pour afficher les devtools et permettre de déboguer plus facilement
    // fonctionne en tandem avec l'extension du navigateur Redux Devtools :
    // Sur chrome : https://chrome.google.com/webstore/detail/redux-devtools/lmhkpmbekcpmknklioeibfkpmmfibljd
    // Sur firefox : https://addons.mozilla.org/en-US/firefox/addon/reduxdevtools/
    composeWithDevTools()
)

/**
	Reducer gérant les actions sur le modèle
**/
function reducer(state, action) {
    var newState = { view: state.view, answer: state.answer }
    switch (action.type) {
        // Mets a jours la view avec une VALEUR spécific
        case 'REMOVE':
            if (state.answer.tech_debug_mode === true)
                console.debug('STORE : REMOVE ANSWER : ' + action.value.key)
            delete newState.answer[action.value.key]
            return newState
        case 'OVERWRITE_ALL_ANSWER':
            if (state.answer.tech_debug_mode === true)
                console.debug('STORE : OVERWRITE_ALL_ANSWER ')
            newState.answer = action.value
            return newState
        case 'SET_VIEW':
            if (state.answer.tech_debug_mode === true)
                console.debug('STORE : SET VIEW : ' + action.value)
            return { view: action.value, answer: state.answer }
        // Mets a jours la view par incrémentation
        case 'INCR_VIEW':
            if (state.answer.tech_debug_mode === true)
                console.debug('STORE : INCR_VIEW : ' + state.view + 1)
            return { view: state.view + 1, answer: state.answer }
        // Mets a jours la view par décrémentation
        case 'DECR_VIEW':
            if (state.answer.tech_debug_mode === true)
                console.debug('STORE : DECR_VIEW : ' + state.view - 1)
            return { view: state.view - 1, answer: state.answer }
        // Mets a jours un champ answer avec un KEY et une VALEUR
        case 'SET':
            if (state.answer.tech_debug_mode === true)
                console.debug(
                    'STORE : SET ANSWER : ' +
                        action.value.key +
                        '  --> ' +
                        action.value.value
                )
            newState.answer[action.value.key] = action.value.value
            if (state.answer.tech_debug_mode === true) console.debug(newState)
            return newState
        // Mets a jours un champ answer avec un KEY et une VALEUR, méthod un peu spécifique car la réponse est un tableau.
        // ajoute au tableau si non existant, supprime du tableau si deja existant.
        case 'SET_MULTI':
            var newArray
            if (state.answer[action.value.key]) {
                // si l'élément existe et est un array
                newArray = state.answer[action.value.key]
                if (newArray.includes(action.value.value)) {
                    // si le tableau contient deja la valeur

                    var arrayTemp = []
                    newArray.forEach((element) => {
                        if (element !== action.value.value) {
                            arrayTemp = arrayTemp.concat([element])
                        }
                    })
                    newArray = arrayTemp
                    if (state.answer.tech_debug_mode === true)
                        console.debug(
                            'STORE : SET_MULTI : REMOVE ' +
                                action.value.key +
                                '  --> ' +
                                action.value.value
                        )
                } else {
                    // sinon
                    newArray = newArray.concat([action.value.value])
                    if (state.answer.tech_debug_mode === true)
                        console.debug(
                            'STORE : SET_MULTI : ADD ' +
                                action.value.key +
                                '  --> ' +
                                action.value.value
                        )
                }
            } else {
                // si l'élement n'existe pas
                newArray = [action.value.value]
                if (state.answer.tech_debug_mode === true)
                    console.debug(
                        'STORE : SET_MULTI : CREATE ' +
                            action.value.key +
                            '  --> ' +
                            action.value.value
                    )
            }
            newState.answer[action.value.key] = newArray
            return newState
        default:
            return state
    }
}

export default store
